import { createSlice } from '@reduxjs/toolkit'

const aboutUsStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: {
        ourReachStats: aboutUsStatus.LOADING,
    },
    errorMessage: {
        ourReachStats: null,
    },
    ourReachStats: {},
}

const aboutUsSlice = createSlice({
    name: 'aboutUs',
    initialState,
    reducers: {
        getOurReachStats: state => {
            state.status.ourReachStats = aboutUsStatus.LOADING
        },
        getOurReachStatsSuccess: (state, action) => {
            state.ourReachStats = action.payload
            state.status.ourReachStats = aboutUsStatus.SUCCESS
        },
        getOurReachStatsError: (state, action) => {
            state.errorMessage.ourReachStats = action.payload
            state.status.ourReachStats = aboutUsStatus.FAILURE
        },
    },
})

const {
    getOurReachStats,
    getOurReachStatsError,
    getOurReachStatsSuccess,
} = aboutUsSlice.actions

export const aboutUsActions = {
    getOurReachStats,
    getOurReachStatsError,
    getOurReachStatsSuccess,
}

export const aboutUsSelectors = {
    errorMessage: state => {
        return {
            ourReachStats: state.aboutUs.errorMessage.ourReachStats,
        }
    },
    isFetching: state => {
        return {
            ourReachStats:
                state.aboutUs.status.ourReachStats === aboutUsStatus.LOADING,
        }
    },
    hasError: state => {
        return {
            ourReachStats:
                state.aboutUs.status.ourReachStats === aboutUsStatus.FAILURE,
        }
    },
    ourReachStats: state => state.aboutUs.ourReachStats,
}

const aboutUsReducer = aboutUsSlice.reducer

export default aboutUsReducer
